import { overParseJson, checkAttendantAndFetch } from '../utils/requestUtils';

const FAVORITE_SITES = 'https://afiliados.uol.com.br/api/FavoriteSite.html';
const HTTP_ERROR = 'HTTP_ERROR';

class SitesApi {
  static buildSitePayload(site) {
    return {
      idtUserSupplierUrl: site.idtUserSupplierUrl,
      desUrl: site.desUrl,
    };
  }

  static async favoriteSite(site) {
    const payload = this.buildSitePayload(site);
    try {
      const fetchResponse = await checkAttendantAndFetch(FAVORITE_SITES, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          // eslint-disable-next-line quote-props
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          siteRequest: payload,
        }),
      });

      const text = await fetchResponse.text();
      const data = overParseJson(text);

      if (fetchResponse.status !== 200) {
        const error = new Error(data.error);
        error.code = HTTP_ERROR;
        error.status = fetchResponse.status;
        throw error;
      }

      return data;
    } catch (error) {
      throw error;
    }
  }
}

export default SitesApi;
